import React from "react";
import { Badge } from "./ui/badge";

const parseFinancialValue = (value) => {
  const raw = String(value || "").trim();
  if (!raw || /nao identificado|não identificado/i.test(raw)) return null;
  const normalized = raw
    .replace(/R\$\s*/i, "")
    .replace(/\./g, "")
    .replace(",", ".")
    .replace(/[^\d.-]/g, "");
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

const getFinancialIndexTone = (item) => {
  const indexName = String(item?.indice || "");
  const value = parseFinancialValue(item?.valor_estimado);
  if (value === null) {
    return {
      card: "rounded-lg border border-slate-200 bg-white p-4 shadow-sm",
      badge: "bg-white text-slate-700 border",
      label: null,
    };
  }

  let status = null;

  if (indexName === "Índice de Liquidez Corrente ou Comum") {
    status = value >= 1.2 ? "good" : value >= 1 ? "medium" : "critical";
  } else if (indexName === "Índice de Liquidez Seca") {
    status = value >= 1 ? "good" : value >= 0.7 ? "medium" : "critical";
  } else if (indexName === "Índice de Liquidez Geral") {
    status = value >= 1 ? "good" : value >= 0.8 ? "medium" : "critical";
  } else if (indexName === "Liquidez Imediata") {
    status = value >= 0.2 ? "good" : value >= 0.1 ? "medium" : "critical";
  } else if (indexName === "Capital Circulante Líquido") {
    status = value > 0 ? "good" : value === 0 ? "medium" : "critical";
  } else if (indexName === "Índice de Participação de Terceiros") {
    status = value <= 1 ? "good" : value <= 2 ? "medium" : "critical";
  }

  if (status === "good") {
    return {
      card: "rounded-lg border border-emerald-200 bg-emerald-50 p-4 shadow-sm",
      badge: "bg-emerald-100 text-emerald-800 border border-emerald-200",
      label: "Bom nível",
    };
  }
  if (status === "medium") {
    return {
      card: "rounded-lg border border-amber-200 bg-amber-50 p-4 shadow-sm",
      badge: "bg-amber-100 text-amber-800 border border-amber-200",
      label: "Nível mediano",
    };
  }
  if (status === "critical") {
    return {
      card: "rounded-lg border border-rose-200 bg-rose-50 p-4 shadow-sm",
      badge: "bg-rose-100 text-rose-800 border border-rose-200",
      label: "Ponto crítico",
    };
  }

  return {
    card: "rounded-lg border border-slate-200 bg-white p-4 shadow-sm",
    badge: "bg-white text-slate-700 border",
    label: null,
  };
};

export default function FinancialIndexCards({ items = [], prefix = "fin-index" }) {
  return (
    <div className="grid gap-3 md:grid-cols-2">
      {items.map((item, idx) => {
        const tone = getFinancialIndexTone(item);
        return (
          <div key={`${prefix}-${idx}`} className={tone.card}>
            <div className="flex items-center justify-between gap-2 mb-1">
              <p className="text-sm font-semibold text-slate-800">{item.indice}</p>
              <Badge variant="secondary" className={tone.badge}>
                {item.valor_estimado || "Não identificado"}
              </Badge>
            </div>
            {tone.label && (
              <p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-slate-600">
                {tone.label}
              </p>
            )}
            <p className="text-xs text-slate-600 leading-relaxed">{item.explicacao}</p>
            <p className="text-xs text-navy mt-2 font-medium leading-relaxed">{item.leitura}</p>
          </div>
        );
      })}
    </div>
  );
}
